import { render, staticRenderFns } from "./genralSearch.vue?vue&type=template&id=e2e247d2"
import script from "./genralSearch.vue?vue&type=script&lang=js"
export * from "./genralSearch.vue?vue&type=script&lang=js"
import style0 from "./genralSearch.vue?vue&type=style&index=0&id=e2e247d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports